module.exports = __webpack_public_path__ + "img/story027.9d3969ed.webp";